module.exports = __webpack_public_path__ + "img/slide.354be730.jpg";